import React, {useState} from "react";
import { checkApi } from "../Authentication/AxiosInstance";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const plans = [
  { duration: "1 Month", price: 99, key: "1M" },
  { duration: "6 Months", price: 499, key: "4M" },
  { duration: "12 Months", price: 999, key: "12M" },
];

export function Pricing() {
  //const [selectedPlan, setSelectedPlan] = useState(null);
  const [error, setError] = useState('');
  const [status, setStatus] = useState('');
  const handlePayment = async (plan) => {
    try {
      const response = await checkApi.post(`${API_ENDPOINT}/pricing/create-order/`, {
            amount: plan.price, 
            duration: plan.duration 
      });

      const data = await response.json();
      const options = {
        key: "YOUR_RAZORPAY_KEY", // Replace with your Razorpay key
        amount: data.amount,
        currency: "INR",
        name: "College Avenue",
        description: `Subscription for ${plan.duration}`,
        order_id: data.id,
        handler: function (response) {
          setStatus("Payment Successful! Transaction ID: " + response.razorpay_payment_id);
        },
        prefill: { email: "user@example.com" },
        theme: { color: "#0284c7" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      setError("Payment error:", error);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-lg border border-gray-200">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">For Students</h2>

        <table className="w-full border-collapse border border-gray-300 rounded-lg overflow-hidden">
          <thead>
            <tr className="bg-primary-500 text-white text-lg">
              <th className="p-4 text-left">Features</th>
              <th className="p-4 text-center">Free</th>
              <th className="p-4 text-center">Premium</th>
            </tr>
          </thead>
          <tbody className="text-gray-700 text-base">
             <tr className="border-t">
              <td className="p-4">Access to Exam Schedules and Notices for AY2025-26</td>
              <td className="p-4 text-center">✅</td>
              <td className="p-4 text-center">✅</td>
            </tr>
            <tr className="border-t">
              <td className="p-4">Access to Cap Round Schedules and Notices for AY2025-26</td>
              <td className="p-4 text-center">✅</td>
              <td className="p-4 text-center">✅</td>
            </tr>
            <tr clclassNameass="border-t">
              <td className="p-4">Seats and Cutoffs for Pre- AY 2023</td>
              <td className="p-4 text-center">✅</td>
              <td className="p-4 text-center">✅</td>
            </tr>
            <tr className="border-t">
              <td className="p-4">Filters & Sorting</td>
              <td className="p-4 text-center text-gray-400">✅</td>
              <td className="p-4 text-center">✅</td>
            </tr>
            <tr className="border-t bg-gray-50">
              <td className="p-4">Seats and Cutoffs for AY 2023 and later</td>
              <td className="p-4 text-center text-gray-400">❌</td>
              <td className="p-4 text-center">✅</td>
            </tr>
            
            <tr className="border-t bg-gray-50">
              <td className="p-4">Download Data (CSV/Excel)</td>
              <td className="p-4 text-center text-gray-400">❌</td>
              <td className="p-4 text-center">✅</td>
            </tr>
            <tr className="border-t">
              <td className="p-4">Personalization Features</td>
              <td className="p-4 text-center text-gray-400">❌</td>
              <td className="p-4 text-center">Coming Soon!</td>
            </tr>
            <tr className="border-t">
              <td className="p-4">Admission Trends and Insights</td>
              <td className="p-4 text-center text-gray-400">❌</td>
              <td className="p-4 text-center">Coming Soon!</td>
            </tr>
            <tr className="border-t">
              <td className="p-4">Priority Support</td>
              <td className="p-4 text-center text-gray-400">❌</td>
              <td className="p-4 text-center">✅</td>
            </tr>
            <tr className="border-t bg-yellow-50 font-bold">
              <td colSpan="3" className="p-4 text-lg text-center text-black">Choose 1 month/ 6 months / 12 months subscription and take advantage of all features in Premium subscription
              </td>
            </tr>
          </tbody>
        </table>
        {error && <p>error</p>}
        {status && <p>status</p>}
        <div className="flex justify-center items-center bg-gray-100 m-5">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {plans.map((plan) => (
              <div key={plan.key} className="bg-white p-6 rounded-lg shadow-md text-center">
                <h2 className="text-xl font-bold mb-2">{plan.duration}</h2>
                <p className="text-2xl font-semibold mb-4">₹{plan.price}</p>
                <button
                  className="bg-primary-500 text-white px-4 py-2 rounded hover:bg-primary-900"
                  onClick={() => handlePayment(plan)}
                >
                  Buy Now
                </button>
              </div>
            ))}
          </div>
        </div>
    </div>
  );
}

